import Slider from "./Slider";
import { Button } from "semantic-ui-react";
import { createBrowserHistory } from "history";

import React from "react";
import "./loginConfirmacion.css";

function refreshPage() {
  localStorage.clear();
  window.location.reload();
}

function loginConfirmacion() {
  const regresaHome = () => {
    history.push("/loginm");
  };
  const history = createBrowserHistory();

  return (
    <>
      <Slider />

      <div className="contenido_confirmacion">
        <p>
          Gracias por tu interés en tomar nuestros cursos. Por favor regresa al
          inicio e inicia sesión con los datos que registraste para poder
          empezar tus cursos. Para poder regresar al inicio haz clic en el botón
          regresar.
        </p>
      </div>

      <div className="boton_confirmacion">
        <Button
          onClick={function () {
            regresaHome();
          }}
        >
          Regresar
        </Button>
      </div>
    </>
  );
}

export default loginConfirmacion;
